import { render, staticRenderFns } from "./ModalNatureOfFeedback.vue?vue&type=template&id=66373a83&"
import script from "./ModalNatureOfFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalNatureOfFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports